import {faFolder} from "@fortawesome/pro-solid-svg-icons/faFolder";
import {faFolderXmark} from "@fortawesome/pro-solid-svg-icons/faFolderXmark";
import {faTag} from "@fortawesome/pro-solid-svg-icons/faTag";
import {IpmRqKeys} from "@twigsby/client-data/lib/Wrappers/ReactQuery/CacheKeys";
import {Button, DropdownMenu, FlexGap, StackHorizontal, Tooltip, useTranslation} from "@twigsby/frontend-framework";
import React from "react";
import {useMailbox} from "../../../Providers/NewMailboxProvider";
import {TagMenu} from "../../Tags/Menus/TagMenu";
import MailActionButtons from "../MailActionButtons";
import MailboxFolders from "../MailboxFolders";

type SelectedMailToolbarContentType = {
    showCustomFolderRemove?: boolean;
}

const SelectedMailToolbarContent = (props: SelectedMailToolbarContentType) => {
    const { t } = useTranslation();
    const {
        mailBoxInfo,
        parsedFilters,
        UpdateMailTags,
        ActionItem,
        RemoveItemsFromFolder
    } = useMailbox();

    return (
        <StackHorizontal gap={FlexGap.ExtraSmall}>
            {props.showCustomFolderRemove && (
                <Tooltip content={t('customFolders.actions.removeFromFolder')}>
                    <Button
                        title={t('customFolders.actions.removeFromFolder')}
                        icon={faFolderXmark}
                        iconOnly={true}
                        squared={true}
                        onClick={() => RemoveItemsFromFolder(mailBoxInfo.customFolderId as number)}
                    />
                </Tooltip>
            )}

            <DropdownMenu
                trigger={
                    <Tooltip content={t('mailboxes.actions.moveToFolder')}>
                        <Button
                            title={t('mailboxes.actions.moveToFolder')}
                            extraClass={'mailbox-folder-menu'}
                            showArrow={true}
                            icon={faFolder}
                            iconOnly={true}
                            squared={true}
                            onClick={() => null}
                        />
                    </Tooltip>
                }
            >
                <MailboxFolders mailItemContext={true} />
            </DropdownMenu>

            <DropdownMenu
                trigger={
                    <Tooltip content={t('mailboxes.actions.tagItems')}>
                        <Button
                            title={t("mailboxes.actions.tagItems")}
                            extraClass={'mailbox-tag-menu'}
                            showArrow={true}
                            icon={faTag}
                            iconOnly={true}
                            squared={true}
                            onClick={() => null}
                        />
                    </Tooltip>
                }
            >
                <TagMenu
                    dataKey={[IpmRqKeys.MAIL_BOX_KEY, parsedFilters]}
                    updateCallback={(e:any, b: boolean) => UpdateMailTags(e, b)}
                />
            </DropdownMenu>

            <MailActionButtons
                iconsOnly={true}
                actionCallback={(value: number) => ActionItem(value)}
            />
        </StackHorizontal>
    )
}

export { SelectedMailToolbarContent }
